import React from 'react';
import StickySidebar from 'components/shared/StickySidebar';
import { useDraggable } from '@dnd-kit/core';
import { useFeatureFlags } from 'hooks';

import ContentOption from './ContentOption';

const DraggableItem = ({ option }) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: option.id,
    data: {
      option,
      fromSidebar: true,
    },
  });

  return (
    <div
      className="JourneyBuilderContentOption-wrapper"
      ref={setNodeRef}
      {...listeners}
      {...attributes}
    >
      <ContentOption option={option} />
    </div>
  );
};

const Sidebar = ({ elements }) => {
  const canEditLearningJourneys = useFeatureFlags([
    'learning-journeys-editing',
  ]);

  return (
    <StickySidebar className="JourneyBuilderSidebar">
      <div className="JourneyBuilderSidebar-header">
        {t('journeys.builder.build')}
      </div>
      {elements.map(option => {
        if (option.type === 'event' && !canEditLearningJourneys) return null;

        return <DraggableItem key={option.id} option={option} />;
      })}
    </StickySidebar>
  );
};

export default Sidebar;
